import loadable from "@loadable/component";
import { fetchRegionalPrices } from "../features/regionalPrices/regionalPricesSlice";

const AppUpdate = loadable(() => import("./AppUpdate.page"));

const loadData = (store) => {
  const { localization: { data } } = store.getState();
  const actions = [fetchRegionalPrices(data)];
  return Promise.all(actions.map((action) => store.dispatch(action)));
};

export default { component: AppUpdate, loadData };
